<template>
    <div>
        <div class="dr-sec-h">{{ scenario.meta.drawerSectionTitle }}</div>
        <p class="dr-sec-p">{{ scenario.meta.drawerSectionDescription }}</p>
        <a class="dr-link-btn" :href="redirectUrl" target="_blank" rel="noopener">
            {{ scenario.meta.drawerLinkLabel }}
            <v-icon class="dr-link-btn__icon" size="13" color="white">mdi-arrow-right</v-icon>
        </a>
    </div>
</template>

<script>
export default {
    name: 'StarterPackDrawerRedirect',
    props: {
        scenario: {
            type: Object,
            required: true,
        },
        redirectUrl: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.dr-sec-h {
    margin-bottom: 8px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13.5px;
    font-weight: 800;
    letter-spacing: -0.01em;
}

.dr-sec-p {
    margin-bottom: 14px;
    color: $muted-new;
    font-size: 12.5px;
    line-height: 1.5;
}

.dr-link-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 11px 17px;
    color: #fff;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 12.5px;
    font-weight: 700;
    text-decoration: none;
    background: $main-new;
    border: 0;
    border-radius: 9px;
    box-shadow: 0 2px 10px rgba(82, 90, 213, 0.26);
    cursor: pointer;
    transition: 0.15s;
}

.dr-link-btn:hover {
    background: #454cc0;
    transform: translateY(-1px);
}

.dr-link-btn__icon ::v-deep .v-icon {
    color: #fff !important;
}
</style>
